module.exports = __webpack_public_path__ + "img/GreatIcon.68687af9.svg";